// extracted by mini-css-extract-plugin
export const container = "footer-module--container--3-Zu_";
export const logo = "footer-module--logo--1C4tZ";